import request from '@/utils/request'

// 通过身份证信息找回账号
export function id_card_input(data) {
  return request({
    url: process.env.VUE_APP_BASE_API_HELPER + '/account_retrieve/id_card_input.do',
    method: 'post',
    data
  })
}

// 通过绑定手机号信息找回账号
export function phone_input(data) {
  return request({
    url: process.env.VUE_APP_BASE_API_HELPER + '/account_retrieve/phone_input.do',
    method: 'post',
    data
  })
}

// 通过订单号找回账号
export function order_input(data) {
  return request({
    url: process.env.VUE_APP_BASE_API_HELPER + '/account_retrieve/order_input.do',
    method: 'post',
    data
  })
}

// 查看完整雷霆账号 -> 获取人脸地址
export function get_face(data) {
  return request({
    url: process.env.VUE_APP_BASE_API_HELPER + '/account_retrieve/get_face.do',
    method: 'post',
    data
  })
}

// 查看完整雷霆账号 -> 校验人脸结果
export function check_face(data) {
  return request({
    url: process.env.VUE_APP_BASE_API_HELPER + '/account_retrieve/check_face.do',
    method: 'post',
    data
  })
}

// 查看完整雷霆账号 -> 输入实名查看
export function check_by_identity(data) {
  return request({
    url: process.env.VUE_APP_BASE_API_HELPER + '/account_retrieve/check_by_identity.do',
    method: 'post',
    data
  })
}

// 人工自助查询-人工找回雷霆账号 *返回结果未加密！
export function retrieve_apply(data) {
  return request({
    url: process.env.VUE_APP_BASE_API_HELPER + '/account_retrieve/manual/apply.do',
    method: 'post',
    data
  })
}

// 人工自助查询-查询手机号是否存在未处理的申请
export function isPhoneApplied(data) {
  return request({
    url: process.env.VUE_APP_BASE_API_HELPER + '/account_retrieve/manual/isPhoneApplied.do',
    method: 'post',
    data
  })
}

// 查询人工申请结果
export function searchByNo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API_HELPER + '/account_retrieve/manual/search.do',
    method: 'post',
    data
  })
}
